exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._395S8{padding-top:30px}._1ekfB,._395S8{margin:0 auto;max-width:1080px}._1ekfB{width:100%;display:block}._2zTXD{font-size:16px;border-bottom:1px solid #dce0e0}._2zTXD,._14yNH{border-radius:0;width:100%;display:block;color:#585858}._14yNH{font-size:14px;line-height:1.43}@media screen and (max-width:768px){._2FrI3{padding:0}}", ""]);

// exports
exports.locals = {
	"container": "_395S8",
	"landingContainer": "_1ekfB",
	"panelHeader": "_2zTXD",
	"panelEmpty": "_14yNH",
	"smPadding": "_2FrI3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/reservation/ReservationContainer.css
// module id = 2634
// module chunks = 15